// components/quiz/AnswerFeedback.jsx
import React from 'react';
import { FaRegHandshake, FaTimesCircle } from 'react-icons/fa';
import Confetti from 'react-confetti';

const AnswerFeedback = ({ isCorrect, showFeedback, helpText, width = 800, height = 600, feedbackRef }) => {
  if (!showFeedback) return null;

  return (
    <>
      {isCorrect && (
        <Confetti width={width} height={height} numberOfPieces={80} recycle={false} />
      )}
      <div
        ref={feedbackRef}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
          marginBottom: '30px',
          padding: '16px 20px',
          borderRadius: '14px',
          backgroundColor: isCorrect ? 'rgba(46, 204, 113, 0.1)' : 'rgba(255, 76, 76, 0.1)',
          boxShadow: '0px 4px 12px rgba(0,0,0,0.05)',
          maxWidth: '600px',
          width: '100%',
          textAlign: 'left',
        }}
      >
        {isCorrect ? (
          <>
            <FaRegHandshake style={{ fontSize: '28px', color: '#2ECC71' }} />
            <p style={{ color: '#2ECC71', fontSize: '16px', margin: 0 }}>{helpText}</p>
          </>
        ) : (
          <>
            <FaTimesCircle style={{ fontSize: '28px', color: '#FF4C4C' }} />
            <p style={{ color: '#FF4C4C', fontSize: '16px', margin: 0 }}>{helpText}</p>
          </>
        )}
      </div>
    </>
  );
};

export default AnswerFeedback;
